<div class="row">
  <div class="columns">
    <h4 class="mos-u-display--inline-block mos-u-spacer--margin-top-sm">Preferences</h4>

    <div class="row">
      <div class="column small-12 medium-3">
        <label class="mos-u-spacer--margin-bottom-sm user-detail-label dsp-label">Language:</label>
      </div>
      <div class="column small-12 medium-9">
        <div class="mos-u-spacer--margin-bottom-sm user-detail-body">{{ (language$ | async) }}</div>
      </div>
    </div>

    <div class="row">
      <div class="column small-12 medium-3">
        <label class="mos-u-spacer--margin-bottom-sm user-detail-label dsp-label">Time Zone:</label>
      </div>
      <div class="column small-12 medium-9">
        <div class="mos-u-spacer--margin-bottom-sm user-detail-body">Timezone</div>
      </div>
    </div>

    <div class="row">
      <div class="column small-12 medium-3">
        <label class="mos-u-spacer--margin-bottom-sm user-detail-label dsp-label">Currency:</label>
      </div>
      <div class="column small-12 medium-9">
        <div class="mos-u-spacer--margin-bottom-sm user-detail-body">{{ (currency$ | async) }}</div>
      </div>
    </div>
  </div>
</div>